var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactRoundLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    fill: "#c6b8a9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4.000000) translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#090000",
    fillOpacity: 0.501961,
    points: "123,26 46,13 66,124"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#562b05",
    fillOpacity: 0.501961,
    points: "252,271 271,181 25,194"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "86,-14 271,2 216,205"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "51,185 271,106 177,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8a6d53",
    fillOpacity: 0.501961,
    points: "150,250 24,135 40,269"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#240200",
    fillOpacity: 0.501961,
    points: "129,35 31,78 72,11"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#602600",
    fillOpacity: 0.501961,
    points: "125,164 115,222 184,191"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e4d0bc",
    fillOpacity: 0.501961,
    points: "62,238 126,186 38,47"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f2f2e9",
    fillOpacity: 0.501961,
    points: "51,13 7,259 -16,-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#705c2e",
    fillOpacity: 0.501961,
    points: "271,127 175,149 206,165"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "53,-14 249,114 248,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "238,234 223,179 270,217"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b96229",
    fillOpacity: 0.501961,
    points: "36,121 97,106 135,33"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#321500",
    fillOpacity: 0.501961,
    points: "212,261 196,213 152,230"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "104,125 233,134 155,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#915526",
    fillOpacity: 0.501961,
    points: "32,107 62,17 31,57"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c7c7b9",
    fillOpacity: 0.501961,
    points: "222,189 200,231 244,271"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#664f37",
    fillOpacity: 0.501961,
    points: "38,254 31,163 78,267"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#341400",
    fillOpacity: 0.501961,
    points: "52,76 112,50 57,17"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#987b5c",
    fillOpacity: 0.501961,
    points: "54,129 -13,132 55,158"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f2fafb",
    fillOpacity: 0.501961,
    points: "34,240 21,137 -16,192"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f8f8f1",
    fillOpacity: 0.501961,
    points: "170,185 227,176 112,146"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fae4ca",
    fillOpacity: 0.501961,
    points: "201,256 117,263 149,232"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#bac2b6",
    fillOpacity: 0.501961,
    points: "240,116 271,204 223,183"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#aa6a3d",
    fillOpacity: 0.501961,
    points: "184,206 136,198 94,271"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "122,-16 139,139 249,1"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f1e8d2",
    fillOpacity: 0.501961,
    points: "66,-4 94,13 40,21"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3e1b0e",
    fillOpacity: 0.501961,
    points: "202,180 201,224 214,193"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b06837",
    fillOpacity: 0.501961,
    points: "48,116 125,76 70,68"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#452f0e",
    fillOpacity: 0.501961,
    points: "128,42 55,15 107,19"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4b0e00",
    fillOpacity: 0.501961,
    points: "216,238 198,234 236,229"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f4fbfc",
    fillOpacity: 0.501961,
    points: "2,-16 28,65 -16,134"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ddd3c9",
    fillOpacity: 0.501961,
    points: "68,111 51,198 78,236"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#462509",
    fillOpacity: 0.501961,
    points: "180,206 120,168 128,194"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#592b06",
    fillOpacity: 0.501961,
    points: "122,75 129,54 123,36"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e5b370",
    fillOpacity: 0.501961,
    points: "271,271 267,228 197,239"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f3f1e5",
    fillOpacity: 0.501961,
    points: "56,104 10,97 23,138"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d2c8b8",
    fillOpacity: 0.501961,
    points: "118,127 104,166 220,164"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#936545",
    fillOpacity: 0.501961,
    points: "17,97 40,75 41,98"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4b3017",
    fillOpacity: 0.501961,
    points: "114,216 116,226 79,231"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "170,143 102,84 233,134"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#929176",
    fillOpacity: 0.501961,
    points: "213,162 247,114 270,136"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d6c7ae",
    fillOpacity: 0.501961,
    points: "49,42 1,-16 58,1"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8e7358",
    fillOpacity: 0.501961,
    points: "48,115 25,178 45,256"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eae1d5",
    fillOpacity: 0.501961,
    points: "112,203 113,94 57,128"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2a1c0d",
    fillOpacity: 0.501961,
    points: "85,271 125,243 126,268"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fefffb",
    fillOpacity: 0.501961,
    points: "221,191 176,172 226,159"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c18f67",
    fillOpacity: 0.501961,
    points: "145,228 182,221 124,197"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#feffff",
    fillOpacity: 0.501961,
    points: "124,69 243,115 137,4"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "271,212 222,185 247,215"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2b1000",
    fillOpacity: 0.501961,
    points: "126,221 142,215 112,205"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a5917e",
    fillOpacity: 0.501961,
    points: "71,157 81,232 111,216"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#372107",
    fillOpacity: 0.501961,
    points: "90,14 65,84 43,45"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#efc9b2",
    fillOpacity: 0.501961,
    points: "122,88 121,37 110,47"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e9dfda",
    fillOpacity: 0.501961,
    points: "234,253 232,237 207,241"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d1d1c4",
    fillOpacity: 0.501961,
    points: "271,168 234,128 246,196"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b56e49",
    fillOpacity: 0.501961,
    points: "160,183 205,184 182,221"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8b4213",
    fillOpacity: 0.501961,
    points: "96,48 112,63 72,71"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9e8c65",
    fillOpacity: 0.501961,
    points: "186,167 184,152 237,154"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#efead9",
    fillOpacity: 0.501961,
    points: "63,83 43,99 42,65"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1b1e1c",
    fillOpacity: 0.501961,
    points: "168,226 197,213 196,237"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#855d2e",
    fillOpacity: 0.501961,
    points: "225,138 201,152 181,147"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ab947f",
    fillOpacity: 0.501961,
    points: "54,156 70,254 37,187"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9e7d63",
    fillOpacity: 0.501961,
    points: "114,155 126,184 149,174"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f8fbfa",
    fillOpacity: 0.501961,
    points: "84,-16 249,35 140,54"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceee8",
    fillOpacity: 0.501961,
    points: "133,224 118,218 119,223"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#82511a",
    fillOpacity: 0.501961,
    points: "237,257 218,271 159,223"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#805725",
    fillOpacity: 0.501961,
    points: "230,224 220,237 271,227"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#706c5e",
    fillOpacity: 0.501961,
    points: "221,195 233,191 230,150"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d1c9b9",
    fillOpacity: 0.501961,
    points: "153,156 233,143 160,176"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "250,52 105,115 242,125"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e1a881",
    fillOpacity: 0.501961,
    points: "76,124 55,116 104,101"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffefe6",
    fillOpacity: 0.501961,
    points: "109,71 104,76 101,64"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d0d2ca",
    fillOpacity: 0.501961,
    points: "34,271 -16,212 34,207"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6e5c48",
    fillOpacity: 0.501961,
    points: "29,271 44,232 99,256"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#bd9f78",
    fillOpacity: 0.501961,
    points: "135,133 184,146 158,147"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d4c6ab",
    fillOpacity: 0.501961,
    points: "252,127 249,-16 271,56"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d2b896",
    fillOpacity: 0.501961,
    points: "49,55 27,60 52,67"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9e663c",
    fillOpacity: 0.501961,
    points: "52,112 69,69 101,101"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#030300",
    fillOpacity: 0.501961,
    points: "159,195 170,198 154,208"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cec1b3",
    fillOpacity: 0.501961,
    points: "61,136 114,192 102,213"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f2bda2",
    fillOpacity: 0.501961,
    points: "108,85 104,105 93,84"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#783614",
    fillOpacity: 0.501961,
    points: "206,184 176,191 213,195"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#59402b",
    fillOpacity: 0.501961,
    points: "129,46 92,17 117,27"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d8ffff",
    fillOpacity: 0.501961,
    points: "198,199 200,194 192,194"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a96b47",
    fillOpacity: 0.501961,
    points: "196,206 111,226 116,250"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d0c3ae",
    fillOpacity: 0.501961,
    points: "154,212 141,216 133,206"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f6f7f5",
    fillOpacity: 0.501961,
    points: "182,13 241,67 78,10"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dba066",
    fillOpacity: 0.501961,
    points: "127,68 120,69 122,91"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "103,106 114,82 163,140"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a0abae",
    fillOpacity: 0.501961,
    points: "233,229 222,192 200,233"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fffffb",
    fillOpacity: 0.501961,
    points: "176,145 263,58 232,135"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#545254",
    fillOpacity: 0.501961,
    points: "251,129 263,144 237,126"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d0c7b7",
    fillOpacity: 0.501961,
    points: "20,155 37,122 5,143"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#89551d",
    fillOpacity: 0.501961,
    points: "164,206 116,206 124,184"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e4d2be",
    fillOpacity: 0.501961,
    points: "126,248 151,233 185,249"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dedad2",
    fillOpacity: 0.501961,
    points: "183,150 78,123 180,187"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#512f13",
    fillOpacity: 0.501961,
    points: "53,60 56,79 111,44"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d5c3ab",
    fillOpacity: 0.501961,
    points: "52,34 45,-16 23,67"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "249,-16 179,34 245,40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactRoundLow);
export default __webpack_public_path__ + "static/media/contact_round_low.a3a2fb2fa896b1c8f7d91a63f2fcc636.svg";
export { ForwardRef as ReactComponent };